//Exporting constants for other files
export const serverResponseConstants = {
  NETWORK_ERROR: "Network Error",
  SERVER_ISSUE: "Unable to access server",
  UNAUTHORIZE_ACCESS: "Unauthorize Access",
  SOMETHING_WENT_WRONG: "Something went wrong",
};
